export default __webpack_public_path__ + "static/media/BIrd_in_flight_prize_21.64b7a151.svg";